import createLucideIcon from '../createLucideIcon';

const RotateCw = createLucideIcon('RotateCwIcon', [
  ['path', { d: 'M21 2v6h-6', key: '1lwg0q' }],
  ['path', { d: 'M21 13a9 9 0 1 1-3-7.7L21 8', key: 'vix499' }],
]);

export default RotateCw;
